// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--3YBg9","indexfeatProduct1":"index-module--indexfeatProduct1--2wjBd","indexfeatProduct2":"index-module--indexfeatProduct2--YdMOd"};